import { createRouter, createWebHistory } from "vue-router";
import site from "../site.json";

export const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, _from, savedPosition) {
    // Browser back/forward: restore where the user was.
    if (savedPosition) return savedPosition;
    // Anchor link (e.g. "/about#team"): scroll to that element.
    if (to.hash) return { el: to.hash, behavior: "smooth" };
    // Normal navigation: scroll to top of the new page.
    return { top: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("./pages/HomePage.vue"),
    },
    {
      path: "/product",
      name: "product",
      component: () => import("./pages/OurProductPage.vue"),
      meta: { bodyClass: "product-page", logoVariant: "orange", headerBg: "secondary" },
    },
    {
      path: "/technology",
      name: "technology",
      component: () => import("./pages/TechnologyPage.vue"),
    },
    {
      path: "/about",
      name: "about",
      component: () => import("./pages/AboutPage.vue"),
    },
    {
      path: "/contact",
      name: "contact",
      component: () => import("./pages/ContactPage.vue"),
    },
    {
      path: "/support",
      name: "support",
      component: () => import("./pages/SupportPage.vue"),
    },
    {
      path: "/privacy-policy",
      name: "privacy-policy",
      component: () => import("./pages/PrivacyPolicyPage.vue"),
    },
    {
      path: "/cookie-policy",
      name: "cookie-policy",
      component: () => import("./pages/CookiePolicyPage.vue"),
    },
    // KAPiSH's own policies, hosted here so the app stores and the apps can link to them. Deliberately
    // in neither the header nor the footer - this site's Privacy Policy is the only page linking to them.
    {
      path: "/legal/kapish/privacy",
      name: "kapish-privacy",
      component: () => import("./pages/LegalDocumentPage.vue"),
      props: { document: "kapish/privacy" },
    },
    {
      path: "/legal/kapish/kids-privacy",
      name: "kapish-kids-privacy",
      component: () => import("./pages/LegalDocumentPage.vue"),
      props: { document: "kapish/kids-privacy" },
    },
    // The stores' "delete data" URL - Google Play wants the steps up front, not inside a policy.
    {
      path: "/legal/kapish/delete-data",
      name: "kapish-delete-data",
      component: () => import("./pages/LegalDocumentPage.vue"),
      props: { document: "kapish/delete-data" },
    },
    // Must stay last: vue-router matches in declaration order, so anything
    // added below this would be shadowed by the wildcard and never reached.
    {
      path: "/:pathMatch(.*)*",
      name: "not-found",
      component: () => import("./pages/NotFoundPage.vue"),
    },
  ],
});

router.afterEach((to) => {
  document.body.className = (to.meta.bodyClass as string) || "";

  // A deploy stamps each route's title into the page it serves (site.json, via the pipeline's site step);
  // this keeps the tab right as the visitor moves between pages without a reload.
  const titles: Record<string, { title?: string }> = site.routes;
  document.title = titles[to.path]?.title ?? site.name;
});
